<h4 class="modal-title text-truncate">{{ title }}</h4>
<div class="modal-header-icons">
    <ng-content></ng-content>
    <kui-icon [name]="icon" id="close" class="ml-1" (click)="close.emit($event)"> </kui-icon>
</div>
